module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 15 Farma Pasa - Izvor.f9e7f7ac.mp3";